import { render } from "./BackPageBtn.vue?vue&type=template&id=7378c042&scoped=true"
import script from "./BackPageBtn.vue?vue&type=script&lang=js"
export * from "./BackPageBtn.vue?vue&type=script&lang=js"

import "./BackPageBtn.vue?vue&type=style&index=0&id=7378c042&lang=scss&scoped=true"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7378c042"]])

export default __exports__